<template>
  <div class="expandable-filters">
    <div class="expandable-filters-header">
      <div class="expandable-filters-leading">
        <slot name="leading" />
      </div>
      <div class="expandable-filters-actions">
        <slot name="actions" />
        <button
          type="button"
          class="btn-filtrar"
          :class="{ active: open }"
          :aria-expanded="open ? 'true' : 'false'"
          @click="toggle"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
          Filtrar
        </button>
      </div>
    </div>

    <transition name="slide">
      <div v-if="open" class="filters-panel" :class="{ 'filters-panel--end': align === 'end' }">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ExpandableFilters',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'start'
    }
  },
  methods: {
    toggle () {
      this.$emit('update:open', !this.open)
    }
  }
}
</script>

<style scoped>
.expandable-filters-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.expandable-filters-leading {
  min-width: 0;
}

.expandable-filters-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.btn-filtrar {
  background-color: #FF5722;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.btn-filtrar.active {
  background-color: #E64A19;
}

.filters-panel {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
  z-index: 20;
}

.filters-panel--end {
  justify-content: flex-end;
}

.filters-panel--end ::v-deep .periodo-filtro {
  flex: 0 1 320px;
}

.filters-panel--end ::v-deep .date-range-dropdown {
  left: auto;
  right: 0;
}

.filters-panel ::v-deep .periodo-filtro {
  min-width: 240px;
  max-width: 320px;
  flex: 1;
}

.filters-panel ::v-deep .periodo-filtro .date-range-trigger {
  min-height: 38px;
  padding: 8px 12px;
  border-radius: 6px;
  border-width: 1px;
  font-size: 13px;
}

.filters-panel ::v-deep .btn-limpar {
  background: none;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #555555;
  cursor: pointer;
  white-space: nowrap;
}

.filters-panel ::v-deep .btn-limpar:hover:not(:disabled) {
  border-color: #FF5722;
  color: #FF5722;
}

.filters-panel ::v-deep .btn-limpar:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.filters-panel ::v-deep .select-filtro {
  padding: 8px 12px;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  background-color: #ffffff;
  font-size: 13px;
  color: #555555;
  cursor: pointer;
}

.filters-panel ::v-deep .select-filtro:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.filters-panel ::v-deep .select-filtro.highlight {
  border-color: #FF5722;
  color: #FF5722;
  font-weight: 600;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
